<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>新增公告</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="subject">
        <input
          type="text"
          class="col-md-4 inputstylesmall"
          placeholder="輸入主旨"
          v-model="subject"
        />
      </div>
    </div>
    <div class="row">
      <div class="timer-setting">
        起始時間：
        <datetime
          v-model="startAt"
          type="datetime"
          input-class="inputstyledatetime"
        ></datetime>
      </div>
      <div class="timer-setting">
        結束時間：
        <datetime
          v-model="endAt"
          type="datetime"
          input-class="inputstyledatetime"
        ></datetime>
      </div>
    </div>
    <div class="row">
      <VueEditor v-model="content"></VueEditor>
    </div>
    <div class="row">
      <button @click="onSubmit" class="btn btn-dark mybtnstyle white_textcolor">
        確認送出
      </button>
    </div>
  </div>
</template>
<script>
import { cookies } from '@/utils/cookies'
import { VueEditor } from 'vue2-editor'
import { Notification, MessageBox } from 'element-ui'
import dayjs from 'dayjs'
import Announcement from '@/assets/js/libs/Announcement'
const announcement = new Announcement()

export default {
  name: 'BoardEditor',
  components: {
    VueEditor,
  },
  data() {
    return {
      announcer: cookies.get('GladName'),
      subject: '',
      content: '',
      startAt: dayjs().subtract(1, 'day').format(),
      endAt: dayjs().format(),
    }
  },
  methods: {
    isValid() {
      if (!this.subject) {
        Notification({
          title: '主旨不得為空',
          type: 'warning',
        })
        return false
      }
      return true
    },
    async createAnnounce() {
      try {
        await announcement.create({
          announcer: this.announcer,
          subject: this.subject,
          content: this.content,
          startAt: this.startAt,
          endAt: this.endAt,
        })
        this.$router.replace('/serviceMain/board')
        Notification({
          type: 'success',
          message: '公告已新增',
        })
      } catch (e) {
        if (e.data.error.type == 'unique') {
          Notification({
            type: 'error',
            message: e.data.error.message,
          })
        } else {
          Notification({
            type: 'error',
            message: '公告新增失敗',
          })
          console.error(e)
        }
      }
    },
    onSubmit() {
      if (this.isValid()) {
        MessageBox.confirm('確定送出公告', '提示', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
        })
          .then(() => {
            this.createAnnounce()
          })
          .catch(() => {
            Notification({
              type: 'info',
              message: '取消送出公告',
            })
          })
      }
    },
  },
}
</script>
<style scoped>
.timer-setting {
  display: inline-block;
  margin: 15px;
}
.mybtnstyle {
  float: right;
  margin-top: 30px;
}
.subject {
  margin: 15px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/announcement/BoardEditor.vue